import { FileType } from './file-types';
import { sanitizeFileName } from './string';

export function downloadFile(
  blob: Blob,
  fileName: string,
  fileType: FileType,
): void {
  const fullFileName = `${sanitizeFileName(fileName)}.${fileType}`;
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fullFileName;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
}

export function parseFilenameFromContentDisposition(
  header: string | null,
): string | null {
  if (!header) return null;
  const utf8Match = header.match(/filename\*=UTF-8''([^\s;]+)/)?.[1];
  if (utf8Match) return decodeURIComponent(utf8Match);
  const quotedMatch = header.match(/filename="([^"]+)"/)?.[1];
  if (quotedMatch) return quotedMatch;
  return header.match(/filename=([^\s;]+)/)?.[1] ?? null;
}
